module.exports = __webpack_public_path__ + "img/card-dark.31195245.svg";